var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
define('areas/activityfeed/parts/getcpmoffice',["require", "exports", "common/parts", "areas/activityfeed/models/dto"], function (require, exports, Parts, Dto) {
    "use strict";
    var GetCPMOffice = (function (_super) {
        __extends(GetCPMOffice, _super);
        function GetCPMOffice(baseUrl) {
            _super.call(this);
            this._baseUrl = baseUrl;
        }
        GetCPMOffice.prototype.process = function (symbol) {
            var _this = this;
            try {
                var url = this._baseUrl + "/sdn/rest/api/directory/organizationapicontract?where=OrganizationData.type==Kanzlei&session=" + symbol.sessionId + "&organization=" + symbol.organizationId;
                Q(jQuery.ajax(url, {
                    type: "GET",
                    async: true,
                    beforeSend: function (xhr, settings) {
                        xhr.setRequestHeader("Authorization", "Bearer " + symbol.token.access_token);
                    },
                    contentType: "application/json"
                }))
                    .then(function (response) {
                    var office = Enumerable.From(response.data)
                        .FirstOrDefault(null);
                    var result = new Dto.OfficeResponse();
                    result.token = symbol.token;
                    result.sessionId = symbol.sessionId;
                    result.organizationId = symbol.organizationId;
                    result.officeId = office.id;
                    _this.output.call(result);
                });
            }
            catch (error) {
                this.error.call(error);
            }
        };
        return GetCPMOffice;
    }(Parts.Part));
    return GetCPMOffice;
});

